import script from "./SensitiveWordManagementNew.vue?vue&type=script&setup=true&lang=js"
export * from "./SensitiveWordManagementNew.vue?vue&type=script&setup=true&lang=js"

import "./SensitiveWordManagementNew.vue?vue&type=style&index=0&id=06742ee1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06742ee1"]])

export default __exports__